import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted, onBeforeUnmount } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { getSocketClient } from '@/utilities/socket';
    import { eventBus } from '@/utilities/event-bus';

    interface LockQueueData {
        componentId: string;
        retrieveLock: () => Promise<boolean>;
        retryFunction: () => void;
    }

    interface LockReleasedPayload {
        componentId: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LockQueueModal',
  setup(__props, { expose: __expose }) {

    const { t } = useI18n();

    const dialogVisible = ref(false);
    const componentId = ref<string | null>(null);
    const retrieveLock = ref<(() => Promise<boolean>) | null>(null);
    const retryFunction = ref<(() => void) | null>(null);

    const openModal = (...args: unknown[]) => {
        const data = args[0] as LockQueueData;
        componentId.value = data.componentId;
        retrieveLock.value = data.retrieveLock;
        retryFunction.value = data.retryFunction;
        dialogVisible.value = true;
    };

    const onLockReleased = async (...args: unknown[]) => {
        const payload = args[0] as LockReleasedPayload;
        if (payload.componentId === componentId.value && retrieveLock.value) {
            const acquired = await retrieveLock.value();
            if (acquired) {
                dialogVisible.value = false;
                if (retryFunction.value) {
                    retryFunction.value();
                }
                resetModal();
            }
        }
    };

    const cancel = () => {
        dialogVisible.value = false;
        resetModal();
    };

    const resetModal = () => {
        componentId.value = null;
        retrieveLock.value = null;
        retryFunction.value = null;
    };

    // Expose for testing
    __expose({
        dialogVisible,
        componentId,
        retrieveLock,
        retryFunction,
        cancel,
        openModal,
        onLockReleased,
        resetModal,
    });

    onMounted(() => {
        eventBus.on('open-lock-queue-modal', openModal);
        const socket = getSocketClient();
        if (socket) {
            socket.on('LOCK_BROADCAST_RELEASED', onLockReleased);
        }
    });

    onBeforeUnmount(() => {
        eventBus.off('open-lock-queue-modal', openModal);
        const socket = getSocketClient();
        if (socket) {
            socket.off('LOCK_BROADCAST_RELEASED', onLockReleased);
        }
    });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_AQButton = _resolveComponent("AQButton")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
    persistent: "",
    "max-width": "700px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "modal-header" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                size: "24",
                color: "#26384B",
                class: "mr-2"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" mdi-lock ", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(_unref(t)('forms.labels.lockInUseTitle')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "content" }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('forms.labels.lockInUse')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "error-buttons" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_AQButton, {
                color: "primary",
                class: "capitalize large",
                onClick: cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.labels.lockInUseLeaveQueue')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})